import { Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useSelector } from 'store/hooks';

type ProtectedLinkProps = {
  pathname: string;
  right?: boolean;
  children?: React.ReactNode;
};

const ProtectedLink: React.FC<ProtectedLinkProps> = ({ pathname, right = true, children }) => {
  const location = useLocation(); // Move useLocation hook inside the component
  const { management } = useSelector((state) => state);
  return right ? (
    <Link
      component={RouterLink}
      to={{
        pathname,
        state: {
          searchParamsPage: management?.searchParams?.page,
          pathname: location.pathname,
          searchParam: location.search,
        },
      }}
      underline="none"
      noWrap
    >
      {children}
    </Link>
  ) : (
    <div>{children}</div>
  );
};

export default ProtectedLink;
